const SearchUserStatus = {
  CompanyJoinScheduled: "COMPANY_JOIN_SCHEDULED",
  LeaveOfAbsence: "LEAVE_OF_ABSENCE",
  Resignation: "RESIGNATION",
  InEmploy: "IN_EMPLOY"};

export { SearchUserStatus };
//# sourceMappingURL=search-user-status.mjs.map
